import {
  JsonSchemaProperty,
  RowDataObject,
  RowDataReducerActionPayload,
  RowDataReducerState,
} from "../../../types";

export const addObjectAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
  property: JsonSchemaProperty,
): RowDataReducerState => {
  const { propertyKey } = payload;
  if (!propertyKey || !property) return state;

  return addObject(propertyKey, property, state);
};

const addObject = (
  propertyKey: string,
  property: JsonSchemaProperty,
  state: RowDataReducerState,
): RowDataReducerState => {
  const properties = property.properties ?? {};

  const newItem: RowDataObject = Object.keys(properties).reduce(
    (acc, key) => ({
      ...acc,
      [key]:
        properties[key].default === undefined ? "" : properties[key].default,
    }),
    {},
  );

  const updatedRowData = {
    ...state.rowData,
    [propertyKey]: newItem,
  };

  return {
    ...state,
    rowData: updatedRowData,
  };
};

export const deleteObjectAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { propertyKey } = payload;
  if (!propertyKey) return state;

  const updatedRowData = {
    ...state.rowData,
    [propertyKey]: null,
  };

  const updatedRowDataErrors = {
    ...state.rowDataErrors,
    [propertyKey]: {},
  };

  return {
    ...state,
    rowData: updatedRowData,
    rowDataErrors: updatedRowDataErrors,
  };
};
